import type { RouteRecordNameGeneric } from '#vue-router';

export const funnelPages = ['luggages', 'passengers', 'insurances', 'billing', 'payment'] as const;

export type FunnelPage = (typeof funnelPages)[number];
export type FunnelPageStatus = 'done' | 'current' | 'upcoming';

// i18n suffixes every route name with its locale: `results___fr` is still `results`.
export const isRoute = (routeName: RouteRecordNameGeneric, name: string): boolean =>
  typeof routeName === 'string' && (routeName === name || routeName.startsWith(`${name}___`));

export const funnelStepperPages: FunnelPage[] = [...funnelPages];

export const currentFunnelPage = (routeName: RouteRecordNameGeneric): FunnelPage | undefined => {
  return funnelPages.find((page) => isRoute(routeName, page));
};

export const nextFunnelPage = (routeName: RouteRecordNameGeneric): FunnelPage | undefined => {
  const page = currentFunnelPage(routeName);
  if (!page) {
    return;
  }
  return funnelPages[funnelPages.indexOf(page) + 1];
};

export const funnelPageStatus = (page: FunnelPage, routeName: RouteRecordNameGeneric): FunnelPageStatus => {
  const current = currentFunnelPage(routeName);
  if (!current) {
    return 'upcoming';
  }
  const currentIndex = funnelPages.indexOf(current);
  const pageIndex = funnelPages.indexOf(page);
  if (pageIndex < currentIndex) {
    return 'done';
  }
  return pageIndex === currentIndex ? 'current' : 'upcoming';
};
